import { isDefined } from "@clipboard-health/util-ts";
import { type CoreMessageType } from "@sendbird/uikit-react/types/utils";
import { isEmpty } from "lodash";

import { logError } from "../lib/analytics";
import { type RenderCustomMessageProps } from "./type";

export function parseFacilityChatMessage(message: CoreMessageType) {
  let facilityMessage;
  try {
    const hasMessage = "message" in message && typeof message.message === "string";
    if (!hasMessage) {
      return undefined;
    }

    if (isValidJson(message.message)) {
      const parsedMessage = JSON.parse(message.message) as { facility: string };
      facilityMessage = parsedMessage.facility;
    } else {
      facilityMessage = message.message;
    }

    return facilityMessage;
  } catch (error) {
    logError("Failed to parse facility message from chat message", {
      error,
      metadata: { message },
    });
    return undefined;
  }
}

export function parseShiftInviteChatMessage(props: RenderCustomMessageProps) {
  const { message } = props;
  const defaultData = { facilityMessage: undefined, shiftInviteId: undefined, status: undefined };
  try {
    const hasData = isDefined(message.data) && !isEmpty(message.data);
    if (!hasData || !isValidJson(message.data)) {
      return defaultData;
    }

    const facilityMessage = parseFacilityChatMessage(message);

    const { shiftInviteId, status } = JSON.parse(message.data) as {
      shiftInviteId: string;
      status: string;
    };

    return { facilityMessage, shiftInviteId, status };
  } catch (error) {
    logError("Shift Invite Chat Message Parsing Error", { error, metadata: { message } });
    return defaultData;
  }
}

export function isValidJson(message: string) {
  try {
    JSON.parse(message);
    return true;
  } catch {
    return false;
  }
}
